/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SkipBackwardIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC0ElEQVR4nLVVSWgUURDtiFFxwQVxPSnqwQXBDVxwPBgY0l1LB35X9SQ6pzSoOXgxNwmIgjfRiydRguAKXjy4XMRgIBcXEEEvChr0oOJycAmJ8mf+LMz0OBPFgs9M/1/1Xv36tXieE2B9AKRfEXWZVyXZbHZ6wPF2YM0DSx+wJERxp++b5d5kBFi/IOsv6Ip22m8/jNYj6yCyfLb7aQtIRpC1N0mS9pYJEKO9QHIWSMbLYKRvkfQ2kF4ElmvA8hBIflaI9DmR7GjtBiTv3e84kF5ijrd5ntdWq2+MWYChHgKWUadvCXub36C4viPLEebcZkSc8yfHjDGzkfW8s5sISPa1QlCJM+tLrwVB1hPFcMo3RLO2XoH0aupjktxLC1GKtCHLdWcz5P0P6TRmSVWy7G7JaGBgYIrflVtJlJ9X2rMhCDjelZaeyHLGPfq5puAWFFlOuVTsdwCF7+KSJ9XEVmwdFd9ORpsSAOvlStpqP1Fug80UIsnZSkaWj0BytNrGGDMNWcesTS15GkEeUbeUCIDlgK0PC1I4J7mJJHfqwmQLs/AOKdlUK0mStJcIbG3YgqoAyRUkGa4jYHlnbZhljed3xauR5UajUk+qCcJI7f8w7FnkCIYtSaMQBUG80AsoPuge5VYzAt/PzQfSD9YhZD1W6FeoYeojk7wuboBZ5QB+FBhrJJPJTAXWu8AalQFIhpDlKZAertUHktMuywarN0fc5knvHwRAF5cKLeA4UzkINVtqckEYbfpL/Dbbyl3/ul/XXkqHSPIKwKyYtPekx0tO+mG0sU7BGDMXSJ85pTdEsqcV4I6Onlm2LZSrG6P9DZVt+gHLo+qBE4TR1rRuWsgolj7rjAMfs/O6qUdBEMx0DWuiMhNk1KYxklxIG5lI8qLVG5cFQNfZqwPpp0ZDH0kfW68z+fyMSYFXi60DO5cxjLpt3ts5HFDMYdi9tBWA3/dssWknlQhbAAAAAElFTkSuQmCC)
 */
export const SkipBackwardIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="m5.73 4.79.05.04 2.17-.02a1.1 1.1 0 0 1 .78 1.87c-.2.2-.49.32-.78.32h-4.8a1.1 1.1 0 0 1-1.1-1.1V1.1a1.1 1.1 0 1 1 2.18 0v2.19l.03.02a11.47 11.47 0 1 1 7.45 20.17v-.02A11.47 11.47 0 0 1 .55 14.54a1.04 1.04 0 1 1 2.04-.46 9.39 9.39 0 1 0 3.15-9.29Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M8.98 10.58c-.3.65-.84 1.01-1.64 1.1v-1.65c.35-.04.68-.17.99-.38.31-.22.53-.49.65-.8h1.48v6.9H8.98v-5.17Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        fillRule="evenodd"
        d="M14.16 15.89c-.5 0-.94-.13-1.34-.39-.4-.27-.72-.67-.95-1.2a5.05 5.05 0 0 1-.35-2c0-.8.12-1.46.35-1.99.23-.54.55-.94.95-1.2.4-.27.85-.4 1.34-.4.5 0 .94.13 1.34.4.4.26.72.66.95 1.2.23.53.35 1.2.35 1.99 0 .8-.12 1.46-.35 2-.23.53-.55.93-.95 1.2-.4.26-.85.39-1.34.39Zm0-1.26c.4 0 .7-.18.9-.54.2-.37.3-.96.3-1.79 0-.83-.1-1.42-.3-1.78a.95.95 0 0 0-.9-.55c-.4 0-.71.18-.91.55a4 4 0 0 0-.29 1.78c0 .83.1 1.42.29 1.79.2.36.5.54.91.54Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
